import { createSlice } from '@reduxjs/toolkit';
import { ALERTS } from 'vio-constants';
import { resetApplication } from '../application/slice';
import appAlertsState from './state';
const appAlertsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => appAlertsState);
    },
    initialState: appAlertsState,
    name: 'appAlerts',
    reducers: {
        appDanger: {
            prepare: message => {
                return {
                    payload: {
                        message
                    }
                };
            },
            reducer: (state, action) => {
                const { message } = action.payload;
                state.active.unshift({
                    alertType: ALERTS.DANGER,
                    message
                });
            }
        },
        appDeleteAlert: {
            prepare: index => {
                return {
                    payload: {
                        index
                    }
                };
            },
            reducer: (state, action) => {
                const { index } = action.payload;
                state.active.splice(index, 1);
            }
        },
        appInfo: {
            prepare: message => {
                return {
                    payload: {
                        message
                    }
                };
            },
            reducer: (state, action) => {
                const { message } = action.payload;
                state.active.unshift({
                    alertType: ALERTS.INFO,
                    message
                });
            }
        },
        appResetAlerts: () => appAlertsState,
        appSuccess: {
            prepare: message => {
                return {
                    payload: {
                        message
                    }
                };
            },
            reducer: (state, action) => {
                const { message } = action.payload;
                state.active.unshift({
                    alertType: ALERTS.SUCCESS,
                    message
                });
            }
        }
    }
});
export const { appDanger, appDeleteAlert, appInfo, appResetAlerts, appSuccess } = appAlertsSlice.actions;
export default appAlertsSlice.reducer;
